import { UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Prüft den Inhalt einer FormControl gegen eine RegEx.
 */
export class FormRegexValidator {

    /**
     * Gibt eine Validierungsfunktion zurück.
     *
     * @param pattern Pattern/RegEx
     * @param key Name des Feldes
     */
    static regex(pattern: string | RegExp, key: string): ValidatorFn {
        return (control: UntypedFormControl): ValidationErrors | null => {
            if (!control.value) {
                return null;
            }
            if (control.value.toString().match(pattern)) {
                return null;
            } else {
                return { [key]: true };
            }
        };
    }
}
